import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface NoGroupModalProps {
  closeModal: () => void
  onCreate: () => void
}

export const NoGroupModal: BaseModalType<NoGroupModalProps> = (props) => {
  const { close, onCreate } = props

  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('IB.RebatesPage.ClientsPage.Adding to group')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('IB.RebatesPage.ClientsPage.Create your first group and automate your work!')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={onCreate}>{t('Create')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
